export const PRICING_CONSTANTS = {
  heading: "Pricing & Plans",
  description:
    "Simple, transparent pricing to suit every need—choose what fits your goals and scale as you grow.",
  plans: [
    {
      frequency: "Monthly",
      price: "$23.99",
      features: [
        "1 Direct Inward Dialing Num.",
        "Caller Name (CNAM) lookup ",
        "Unlimited calls to US & Canada ",
        "3-way call conferencing ",
      ],
    },
    {
      frequency: "Annual",
      price: "$239.90",
      features: ["Includes all of the monthly plan", "Cost-effective annual billing"],
    },
  ],
  btnText: "Get Started For Free",
};
